import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import mobilePreview from './../configureManage/mobilePreview';
import { INITAL } from '../configureManage/utils';
import { pageModal } from '../configureManage/mobilePreview/components';
export default {
  props: {
    itemObj: {
      type: Object,
      default() {
        return {};
      }
    },
    itemIndex: {
      type: Number,
      default: -1
    },
    isMouse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    mobilePreview,
    pageModal
  },
  data() {
    return {
      arr2: [],
      themeColor: '',
      INITAL,
      isObscuration: false,
      pageDescriptionConfig: {},
      pagePopUp: false,
      pagePopUpConfig: {},
      pageModalShow: false
    };
  },
  created() {
    this.$nextTick(() => {
      console.log(this.itemObj, 22224);
      let arr = [this.INITAL[this.itemObj.controlsGroupPageType][0]];
      arr[0].isClick = false;
      arr[0].style = {
        isDisplayNavigation: this.itemObj.controlsGroupConfig.isDisplayNavigation,
        titleColor: this.itemObj.controlsGroupConfig.isDisplayNavigation,
        backgroundColor: this.itemObj.controlsGroupConfig.backgroundColor,
        backgroundImage: this.itemObj.controlsGroupConfig.backgroundImage,
        themeColor: this.itemObj.controlsGroupConfig.themeColor,
        pageDescription: this.itemObj.controlsGroupConfig.pageDescription,
        pageDescriptionConfig: this.itemObj.controlsGroupConfig.pageDescriptionConfig,
        pagePopUp: this.itemObj.controlsGroupConfig.pagePopUp,
        pagePopUpConfig: this.itemObj.controlsGroupConfig.pagePopUpConfig
      };
      this.pageDescription = this.itemObj.controlsGroupConfig.pageDescription;
      this.pageDescriptionConfig = this.itemObj.controlsGroupConfig.pageDescriptionConfig;
      this.pagePopUp = this.itemObj.controlsGroupConfig.pagePopUp;
      this.pagePopUpConfig = this.itemObj.controlsGroupConfig.pagePopUpConfig;
      if (this.pagePopUp) {
        this.pageModalShow = true;
      } else {
        this.pageModalShow = false;
      }
      this.itemObj.controlsGroupConfig.controlsConfig.map(item => {
        let obj = {
          controlsId: item.controlsId,
          controlsMark: item.controlsMark,
          isClick: false,
          style: item.controlsObject
        };
        arr.push(obj);
      });
      this.arr2 = arr;
      this.themeColor = this.arr2[0].style.themeColor;
    });
  },
  methods: {
    enters() {
      if (!this.isMouse) {
        return false;
      }
      this.isObscuration = true;
    },
    leaver() {
      if (!this.isMouse) {
        return false;
      }
      this.isObscuration = false;
    },
    homeFun() {
      this.$emit('setHome', this.itemIndex);
    }
  }
};